import React, { useState } from 'react'
import "./bookNowBtn.css"
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import HourGlass from '../loaders/hourGlass/HourGlass';
import BackDrop from '../backDrop/BackDrop';

import "./bookNowBtn.css"
import RingLoader from '../loaders/ringLoader/RingLoader';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateEnrollCheck } from '../../redux/features/enroll/enrollSlice';
function BookNowBtn() {
    const [backDropStatus, set_backDropStatus] = useState(false)
    const [loading, set_loading] = useState(false)
    //const [accCreateState, set_accCreateState] = useState(false)
    const isEnroll = useSelector(state => state.enroll.isEnroll)
    const fbp = useSelector(state => state.fb?.fbp)
    const fbc = useSelector(state => state.fb?.fbc)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    

    const generate_fb_purchaseEvent = async ()=>{
        
    }

    const handle_verifyPayment = (data) => {
        var options = {
            "key": process.env.REACT_APP_RAZORPAY_KEY_ID, // Enter the Key ID generated from the Dashboard
            "amount": data?.amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            "currency": "INR",
            "name": "DSA Simplified", //your business name
            "description": "Enroll Fee",
            "image": "../../../favicon.webp",
            "order_id": data?.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
            "handler": async function (response) {
                // alert(response.razorpay_payment_id);
                // alert(response.razorpay_order_id);
                // alert(response.razorpay_signature)
                const body = {
                    ...response
                }
                console.log(body, "order/verify");

                // backDropStatus(true)
                set_loading(true)
                await axios.post(process.env.REACT_APP_SERVER + "/api/v1/razorpay/order/verify", body)
                    .then((res) => {
                        if (res?.data?.success) {
                            let payent_id = res?.data?.content?.razorpay_payment_id
                            
                            localStorage.setItem("payent_id", payent_id)

                            dispatch(updateEnrollCheck(true))
                            navigate("/enroll")
                        } else {
                            alert("Transaction Failed")
                        }
                    })
                    .catch((err) => {
                        console.log(err);

                    }).finally(() => {
                        //backDropStatus(false)
                        set_loading(false)
                    })
            },
            "prefill": { //We recommend using the prefill parameter to auto-fill customer's contact information, especially their phone number
                "name": "", //your customer's name
                "email": "",
                "contact": ""  //Provide the customer's phone number for better conversion rates 
            },
            "notes": {
                "address": "Razorpay Corporate Office"
            },
            "theme": {
                "color": "#3399cc"
            }
        };
        var rzp1 = new window.Razorpay(options);
        rzp1.on('payment.failed', function (response) {
            // alert(response.error.code);
            // alert(response.error.description);
            // alert(response.error.source);
            // alert(response.error.step);
            // alert(response.error.reason);
            // alert(response.error.metadata.order_id);
            // alert(response.error.metadata.payment_id);
        });
        rzp1.open();

    }




    const handle_payment = async () => {
        try {
            const paymentBody = {
                "amount": (299 * 100),
                "receipt": "dsaSiplified",
                "notes": [
                    { "note1": "ok1" },
                    { "note2": "ok2" },
                    { "note3": "ok2" }
                ]
            }

            const fbEventBody = {
                event_source_url: window.location.href,
                browser_id: fbp,
                click_id: fbc,
                currency: "INR",
                value: 299
              }

            //Payment
            set_loading(true)
            await axios.post(process.env.REACT_APP_SERVER + "/api/v1/razorpay/order/create", paymentBody)
            .then((res) => {
                handle_verifyPayment(res.data?.content)
            }).catch((err) => {
                console.error(err)
            }).finally(() => {
                set_loading(false)
            })

            //initiateCheckout Event
            await axios.post(process.env.REACT_APP_SERVER+"/api/v1/fb-event/initiateCheckout",fbEventBody)
            .then((res)=>{
            console.log(res.data.message);
            })
            .catch((err)=>{
            console.error(err.data.message);  
            })


        } catch (error) {

            alert("Something Went Wrong, Try later")
        }
    }

    return (
        <>
            <Button onClick={() => isEnroll ? navigate("/enroll") : handle_payment()} className='nav-contactBtn' >
                {loading ?
                    <RingLoader /> :
                    <span className='no-line-break'>
                        {isEnroll ? "Create Account" : "Enroll Now"}
                    </span>
                }
            </Button>
            {/* <BackDrop open={backDropStatus} ><HourGlass /></BackDrop> */}
        </>
    )
}

export default BookNowBtn